$(function() {
    
    $('.js-tooltipster').tooltipster({
		theme: 'tooltipster-shadow',
		trigger: 'both',
      triggerOpen: {
          mouseenter: true,
          touchstart: true,
          click: true,
          tap: true
      },
      triggerClose: {
          click: true,
          tap: true,
          mouseleave: true,
          originClick: true,
          touchleave: true
      },
	    functionInit: function(instance, helper){
        var $origin = $(helper.origin),
          dataOptions = $origin.attr('data-tooltipster');
        if(dataOptions){
          dataOptions = JSON.parse(dataOptions);
          $.each(dataOptions, function(name, option){
            instance.option(name, option);
          });
        }
	    }
		});

});
